module.exports = __webpack_public_path__ + "media/img/alhoor-favicon-cffd251ae8020b1fb73e40363185ac9e.svg";